import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `.modal` (centered popup, fade+scale in) + head/body/foot.
export const styles = {
  modal: {
    kVAEAm: "xixxii4",
    kbCHJM: "x1nrll8i",
    k87sOh: "xwa60dl",
    k3aq6I: "xjba2rz",
    kY2c9j: "x16k0d88",
    kzqmXN: "x14rvwrp",
    ks0D6T: "x1c9y9jp",
    kskxy: "x1qnz03t",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kWkggS: "x1k55akt",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xaj8nyx",
    kaIpWk: "xgkqh4w",
    kGVxlE: "xkqgayn",
    kSiTet: "xg01cxk",
    k33iCy: "xlshs6z",
    kmkexE: "x139s4k2",
    $$css: true
  },
  sm: {
    kzqmXN: "xht4xr3",
    $$css: true
  },
  wide: {
    kzqmXN: "xhfkudu",
    kskxy: "xycw5lm",
    $$css: true
  },
  detail: {
    kzqmXN: "xdpfuu1",
    $$css: true
  },
  lg: {
    kzqmXN: "x1t3asrw",
    kskxy: "xycw5lm",
    $$css: true
  },
  show: {
    kSiTet: "x1hc1fzr",
    k33iCy: "xnpuxes",
    k3aq6I: "x1t2qqyw",
    $$css: true
  },
  head: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "x1qughib",
    kOIVth: "x1mnnc3i",
    kmVPX3: "xwx7bon",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xra1o3",
    $$css: true
  },
  headLeft: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1fwedmp",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  title: {
    kMv6JI: "xpc6l4x",
    kGuDYH: "x1edk5ry",
    k63SB2: "xomqrzn",
    kMwMTN: "x1oezkus",
    kogj98: "x1ghz6dp",
    $$css: true
  },
  iconBtn: {
    kmuXW: "x2lah0s",
    kzqmXN: "x1td3qas",
    kZKoxP: "x10w6t97",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kaIpWk: "x1d0dq8e",
    ksu8eU: "xng3xce",
    kWkggS: "xjbqb8w",
    kMwMTN: "x1em627c",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1k3q35m",
    kI3sdo: "x1a2a7pz xx4dj4q",
    kGzVvX: "x5lqt2c",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  body: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1uw14oh",
    kmVPX3: "x1bn5kwv",
    kORKVm: "x1odjw0f",
    kUk6DE: "x98rzlu",
    $$css: true
  },
  foot: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "x13a6bvl",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1mnnc3i",
    kmVPX3: "x8t73i1",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "x1p7xzfl",
    $$css: true
  }
};